// extracted by mini-css-extract-plugin
module.exports = {"container":"Pokemon_container__23ENQ","containerCard":"Pokemon_containerCard__2yxhS","id":"Pokemon_id__2eZGy","name":"Pokemon_name__1ylKG","types":"Pokemon_types__4NoMW"};